import React from 'react';
import LocationTemplate from './LocationTemplate';

const KittyHawkPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Kitty Hawk"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27949"]}
      latitude={36.0626}
      longitude={-75.7018}
      population={3708}
      historicalFact="Name possibly derived from Native American 'Chickahawk,' famous as the Wright Brothers' flight location."
      nearbyTowns={[
        "Kill Devil Hills, NC",
        "Southern Shores, NC",
        "Duck, NC",
        "Nags Head, NC",
        "Manteo, NC",
        "Colington, NC",
        "Point Harbor, NC",
        "Elizabeth City, NC"
      ]}
    />
  );
};

export default KittyHawkPage;